module.exports = "<div class=\"main-timeline\">\r\n\t<div #context></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/overlays/components/timeline/timeline.component.html
// module id = ../../../../../src/app/packages/overlays/components/timeline/timeline.component.html
// module chunks = main